export default "data:image/webp;base64,UklGRkQAAABXRUJQVlA4TDgAAAAvJ4AGAIWSAGiYCjQnDRnArtTTMwQBJEA5vek4rUEWDGKRURLz6Uq6/xOgrh8VbTPH0h/43lx0AQ=="